<template>
    <!-- add role modal -->
            <!--  -->
            <div
                class="modal fade mt-10"
                id="AddRoleModal"
                tabindex="-1"
                aria-hidden="true"

            >
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header bg-transparent">
                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="modal-body p-3 pt-0">
                            <div class="text-center mb-2">
                                <h1 class="mb-1">Add a Role</h1>
                                <p>Add a Role as per your requirements.</p>

                            </div>

                            <form
                                id="editPermissionForm"
                                class="row"
                                onsubmit="return false"
                                novalidate="novalidate"
                            >
                                <div class="col-sm-6">
                                    <label
                                        class="form-label"
                                        for="rolename"
                                        >Role Name</label
                                    >
                                    <input
                                        type="text"
                                        id="rolename"
                                        name="name"
                                        class="form-control"
                                        placeholder="Role Name"
                                        tabindex="-1"
                                        data-msg="Please enter role name"
                                        v-model="roleName"
                                    />
                                </div>
                                <div class="col-sm-6">
                                    <label
                                        class="form-label"
                                        for="display_name"
                                        >Display Name</label
                                    >
                                    <input
                                        type="text"
                                        id="displayname"
                                        name="display_name"
                                        class="form-control"
                                        placeholder="Display Name"
                                        tabindex="-1"
                                        data-msg="Please enter a display name"
                                        v-model="roleDisplayName"
                                    />
                                </div>
                                <div class="col-md-12 col-12 mb-1">
                                    <label for="description">Description</label>
                                    <textarea class="form-control" id="description" name="description" rows="3" placeholder="Description" v-model="roleDescription"></textarea>
                                </div>

                                <div class="col-sm-12 ps-sm-0 d-flex justify-content-between right">
                                    <button type="reset" class="btn btn-outline-secondary mt-2 waves-effect waves-float waves-light" data-bs-dismiss="modal" aria-label="Close" >
                                        Discard
                                    </button>
                                    <button
                                        @click="getPermissionList()"
                                        class="btn btn-primary mt-2 waves-effect waves-float waves-light"
                                        data-bs-toggle="modal"
                                        data-bs-target="#twoFactorAuthAppsModal"
                                    >
                                        <span class="me-50">Continue</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
                                    </button>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="twoFactorAuthAppsModal" tabindex="-1" aria-labelledby="twoFactorAuthAppsTitle" style="display: none;" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-scrollable">
                    <div class="modal-content">
                        <button  type="reset" class="hidden btn btn-outline-secondary mt-2 me-1 waves-effect" data-bs-toggle="modal" data-bs-target="#twoFactorAuthAppsTitle" aria-label="Close">
                            Back
                        </button>
                        <div class="modal-body pb-5 px-sm-5 mx-50">
                            <CreditFixrrLoader styleType="dynamic" :toggle="fetchdataLoader"/>
                            <div class="text-center mb-2">
                                <h3 class="mb-1">Permissions</h3>
                                <p class="mb-2 mt-2">
                                    Choose the permissions to assign the role
                                </p>
                            </div>
                            <form class="row gy-1" onsubmit="return false" v-if="Object.keys(permissionList).length">
                                <!--  -->
                                <div class="col-12 mt-1">
                                    <div class="">
                                        <input class="form-check-input permissionchecker" type="checkbox" id="CheckAll" value="" v-on:click="selectAll($event)"/>
                                        <label class="form-check-label " for="checkAll"> Select All</label>
                                    </div>
                                </div>
                                <div class="col-12 mb-2" v-for="(perList,index) in permissionList" :key="index">
                                  <div class="row mt-1">
                                      <div class="col-12 d-flex" style="padding-left: unset;">
                                          <div>
                                              <h5 class="mr-8">{{perList.permission_type}}</h5>
                                          </div>
                                          <div class="ml-8" style="margin-left: 26px;margin-top: -3px;">
                                              <input class="form-check-input permissionchecker" :class="perList.slug+'_val'" type="checkbox" :id="perList.slug+'_val'" :value="perList.slug+'_val'" v-on:click="selectComponents($event,perList.slug+'_val')"/>
                                              <label class="form-check-label " for="checkAll"> Select All {{perList.permission_type}} Options</label>
                                          </div>

                                      </div>

                                      <div class="form-check col-4 d-flex" v-for="(perlist,index) in perList.attached_attr" :key="index">
                                          <input class="form-check-input permissionchecker" :class="perList.slug+'_val'" type="checkbox" :value="perlist.id"  v-model="updatePermission"/>
                                          <label class="form-check-label " :for="'permission-'+perlist.id"> {{perlist.name}} </label>
                                      </div>
                                  </div>

                                </div>
                                <!--  -->
                                <!-- checked Items -->

                                <div class="col-12 d-flex justify-content-between">
                                    <button type="button" class="btn btn-outline-secondary mt-2 me-1 waves-effect" data-bs-toggle="modal" data-bs-target="#AddRoleModal" aria-label="Close" ref="hidder">
                                    Back
                                    </button>
                                    <button type="submit" class="btn btn-primary mt-2 waves-effect waves-float waves-light" @click="createRole">
                                        Create Role
                                    </button>
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>


</template>
<script>
import CreditFixrrLoader from '../../loader/CreditFixrrLoader.vue'
import {ref} from 'vue'
export default{
    name:'AddRoleComponent',
    components: {
        CreditFixrrLoader
    },
    data(){
        return{
            roleName:'',
            roleDisplayName:'',
            roleDescription:'',
            updatePermission:[],
            permission:[],
            fetchdataLoader:false,
            showNextModal:false,
            permissionList:[
                {display_name:'Manage Comments',name:'manage_comments'},
                {display_name:'Add Comments',name:'add_comments'},
                {display_name:'Delete Comments',name:'delete_comments'},
                {display_name:'Reply Comments',name:'reply_comments'}
            ]
        }
    },
    setup(_,{emit}){
        return{
            hidder:ref(),
        }
    },
    created(){
        // this.getPermissionList()
    },
    methods:{
        getPermissionList(){
            this.fetchdataLoader = true;
            this.permissionList = [];
            this.showModal()
            axios.get(`${baseUrl}/rbac/roles/allpermissions`).then(response => {
                let permissions =response.data.data;
                this.permissionList = permissions;
                this.fetchdataLoader = false;
            });
        },
        createRole(){
            let data = {
                name:this.roleName,
                display_name:this.roleDisplayName,
                description:this.roleDescription,
                permissions:this.updatePermission
            };
            axios.post(`${baseUrl}/rbac/roles`,data).then(({data})=>{
                if(data.message == 'success' && data.error == false){
                    toastr.success('Role addedd successfully','success')
                    setTimeout(()=>{
                        window.location = '/rbac/roles'
                    },4000)
                }else{
                    toastr.error('Role not added','error')
                }

            }).catch((error)=>{
                console.log(error)
                toastr.error('Role was not added','error')
            })
        },
        selectAll(e){
            let checkStatus = event.target.checked;

            if(checkStatus){
                let valSelect = this.permissionList;

                let selected = [];
                valSelect.forEach(element => {

                    element.attached_attr.forEach(permissions=>{
                       selected.unshift(permissions.id);
                    })
                });
                this.updatePermission = selected;

            }else{
                event.target.checked=false;
                this.updatePermission=[];
            }

        },
        selectComponents(e,element){
            // check if all values are checkcreds
            let checkStatus = e.target.checked;
            let selectedElement = [];
            let varSelected = this.updatePermission;
            let selarray = Object.values(varSelected)
            if(checkStatus){

                let classname = $(`.${element}`).each(function(){
                  if(this.value){
                    if(this.value !== element){
                      selectedElement.unshift(parseInt(this.value));
                    }
                  }
                });
                selectedElement.map((item)=>{
                  if(selarray.indexOf(item)>-1){
                  }else{
                    varSelected.unshift(item);
                  }
                });
            }else{
              let classname = $(`.${element}`).each(function(){
                if(this.value){
                  if(this.value !== element){
                    selectedElement.unshift(parseInt(this.value));
                  }
                }
              });
              var arr = Object.values(varSelected);
              var removeStr = selectedElement;

              arr = arr.filter(function(val){
                return (removeStr.indexOf(val) == -1 ? true : false)
              })
              this.updatePermission=  arr;
            }
        },
        showModal(){
            this.showNextModal = !this.showNextModal
        }
    }
};
</script>
